export default function assertExhaustive(
  value: never,
  message = 'Reached unexpected case in exhaustive switch'
): never {
  // eslint-disable-next-line no-console
  console.error(`${message}: ${JSON.stringify(value)}`);
  throw new Error(message);
}
